var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"id":"modal-tutorial","title":_vm.computedTitle}},[_c('span',{staticClass:"close",on:{"click":_vm.onClose}},[_c('x-icon',{attrs:{"size":"1.25x"}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }